export default __webpack_public_path__ + "static/media/ManropeBold.e171efa5.woff2";